/**
 * NotFoundPage
 *
 * This is the page we show when the user visits a url that doesn't have a route
 *
 */

import React from "react";

import { Result, Button } from "antd";

export default function NotFound({ history }) {
  return (
    <>
      <Result
        status="404"
        title="404"
        subTitle="صفحه مورد نظر یافت نشد"
        extra={
          (
            <Button type="primary" onClick={() => history.push("/panel")}>
              خانه
            </Button>
          )
        }
      />
    </>
  );
}
